// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"374":"30765ed6","558":"dc911a5b","864":"eb8c19cb","941":"d6558b95","996":"8c9357cd"}[chunkId] + ".css";
};